<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.attached_document') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.invoice_receipt') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.service_result') }}</v-tab>
            <v-tab v-if="receipt_status_type_code === '4305' || receipt_status_type_code === '4308'">{{ $t('myrequest.view.fields.result') }}</v-tab>

            <v-tab-item>
              <RequestInformation
                :receipt_no.sync = receipt_no
              />
              <div>
                <h2 class="m_title">{{ $t('myrequest.view.fields.research_types') }}</h2>
                <div class="ml-5">
                  <v-flex class="item_box bd_none">
                    <div class="input_checkbox_type_basic row ma-0">
                      <v-radio-group
                        v-model="research.research_type_code"
                        class="view__radio"
                      >
                        <template v-for="(item, index) in $vuetify.rtl ? researchTypeListAr : researchTypeListEn">
                          <v-radio
                            :label="item.text"
                            :value="item.value"
                            :key="index"
                            style="height:30px;"
                            readonly
                          ></v-radio>
                        </template>
                      </v-radio-group>
                    </div>
                  </v-flex>
                  <v-flex class="item_box bd_none" v-if="research.research_type_code === '5807'">
                    <div class="input_text_type_basic file_type wp50 mt-0 ml--10" style="min-height : 50px;">
                      <v-chip
                        label
                        dark
                        color="gray"
                        v-if="research.id_card_file_name != ''"
                      >
                        <v-icon>{{fnGetFileIcon(research.id_card_file_ext)}}</v-icon>
                        {{ research.id_card_file_name }}
                      </v-chip>
                    </div>
                  </v-flex>

                  <v-flex class="item_box bd_none">
                    <div>
                      <v-textarea
                        outlined
                        class="br_none mt-15 text_icon_type type2 ie_textarea login_text_field"
                        width="100%"
                        readonly
                        v-model="research.notes"
                      >
                      </v-textarea>
                    </div>
                  </v-flex>
                </div>

                <h2 class="m_title">{{ $t('myrequest.view.fields.search_scope') }}</h2>
                <div class="ml-5">
                  <v-flex class="item_box bd_none">
                    <div class="input_checkbox_type_basic row ma-0">
                      <v-checkbox
                        :label="$t('myrequest.view.fields.egyptian_patents')"
                        v-model="research.ind_search_egyptian"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.foreign_patents')"
                        v-model="research.ind_search_foreign"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                    </div>
                  </v-flex>

                  <v-flex class="item_box d-flex bd_none">
                    <template v-for="(item, index) in research.research_digital_patents" class="mb-15">
                      <v-spacer class="hidden_lr5" :key="index+'_spc'"></v-spacer>
                      <v-chip
                        label
                        dark
                        color="green"
                        :key="index"
                      >{{ item.patent_no + ' (' + item.country_code + ')' }}</v-chip>
                    </template>
                  </v-flex>

                  <v-flex class="item_box bd_none" v-if="research.digital_doc_file_name != ''">
                    <div class="input_text_type_basic file_type wp50 mt-10 ml--10" style="min-height : 50px;">
                      <v-chip
                        label
                        dark
                        color="gray"
                      >
                        <v-icon>{{fnGetFileIcon(research.digital_doc_file_ext)}}</v-icon>
                        {{ research.digital_doc_file_name }}
                      </v-chip>
                    </div>
                  </v-flex>
                </div>

                <h2 class="m_title mt-20">{{ $t('myrequest.view.fields.required_research_language') }}</h2>
                <div class="ml-5">
                  <v-flex class="item_box bd_none">
                    <div class="input_checkbox_type_basic row ma-0">
                      <v-checkbox
                        :label="$t('myrequest.view.fields.arabic2')"
                        v-model="research.ind_lang_arabic"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.english2')"
                        v-model="research.ind_lang_english"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                    </div>
                  </v-flex>
                </div>

                <h2 class="m_title mt-20">{{ $t('myrequest.view.fields.the_purpose_of_the_research') }}</h2>
                <div class="ml-5">
                  <v-flex class="item_box">

                    <div class="input_checkbox_type_basic ma-0">
                      <v-checkbox
                        :label="$t('myrequest.view.fields.purpose_0')"
                        v-model="research.ind_to_start"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.purpose_1')"
                        v-model="research.ind_scientific_dissertation"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.purpose_2')"
                        v-model="research.ind_solve_tech_problem"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.purpose_3')"
                        v-model="research.ind_feasibility_study"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('myrequest.view.fields.purpose_4')"
                        v-model="research.ind_other"
                        value="Y"
                        false-value="N"
                        hide-details
                        readonly
                        class="view__chkbox"
                      ></v-checkbox>
                    </div>
                    <v-col cols="6" class="pa-0" v-if="research.ind_other === 'Y'">
                      <div class="input_text_type_basic mt-15">
                        <v-text-field
                          :placeholder="$t('myrequest.view.fields.enter_the_purpose_of_the_research')"
                          v-model="research.other_purpose"
                          dense
                          outlined
                          hide-details
                          class="ft-size12"
                          readonly
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-flex>
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <DocumentViewer
                :items="documentFileList"
              />
            </v-tab-item>

            <v-tab-item>
              <payment
                :payments.sync="paymentList"
                :receipt_no="receipt_no"
                :payment_history_seq="payment_history_seq"
                :query="$route.query"
                paid="Y"
              >
              </payment>
            </v-tab-item>

            <v-tab-item>
              <DeliverableViewer
                :items="deliverableFileList"
              />
            </v-tab-item>

            <v-tab-item v-if="receipt_status_type_code === '4305' || receipt_status_type_code === '4308'">
              <h2 class="m_title mt-15">{{ $t('myrequest.view.fields.result') }}</h2>
              <div>
                <v-row class="ma-0">
                  <v-col cols="12" class="pt-20">
                    <v-textarea
                      outlined
                      class="login_text_filed"
                      v-model="result_notes"
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import DeliverableViewer from '@/components/layout/DeliverableViewer'
import RequestInformation from './RequestInformation'
import Payment from '@/components/layout/Payment'

export default {
  components :{
    DocumentViewer,
    DeliverableViewer,
    RequestInformation,
    Payment
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      payment_history_seq: null,
      paymentList: [],

      documentFileList: [],
      deliverableFileList : [],

      researchTypeListAr : [],
      researchTypeListEn : [],
      periodTypeListAr: [],
      periodTypeListEn: [],

      receipt_status_type_code: '',
      result_notes: '',

      research : {
        company_name_ar : '',
        research_type_code : '',
        ind_search_egyptian : 'N',
        ind_search_foreign : 'N',
        digital_doc_file_key : '',
        digital_doc_file_name : '',
        digital_doc_file_ext : '',
        ind_lang_english : 'N',
        ind_lang_french : 'N',
        ind_lang_german : 'N',
        ind_lang_other : 'N',
        other_language : '',
        search_period_type_code : '',
        ind_to_start : 'N',
        ind_scientific_dissertation : 'N',
        ind_solve_tech_problem : 'N',
        ind_feasibility_study : 'N',
        ind_other : 'N',
        other_purpose : '',
        notes: '',
        research_digital_patents : [],
        id_card_file_key : '',
        id_card_file_name : '',
        id_card_file_ext : ''
      }
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
    this.fnGetDocumentFileList()
    this.fnGetDeliverableFileList()
    this.fnGetPaymentList()
  },
  methods: {
    fnInit(){
      let options = {
        upper_code: '5800'
      }
      utils.fnGetCodeList(options).then(list => {
        this.researchTypeListAr = list.ar
        this.researchTypeListEn = list.en
        this.research.research_type_code = this.researchTypeListAr[0].value
      })

      options = {
        upper_code: '5900'
      }
      utils.fnGetCodeList(options).then(list => {
        this.periodTypeListAr = list.ar
        this.periodTypeListEn = list.en

        this.research.search_period_type_code = this.periodTypeListAr[0].value
      })

      this.fnGetResearchService()
      this.fnGetReceiving()
    },
    fnGetResearchService(){
      requestApi({
        url: '/receivings/research/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.research.company_name_en             = res.data.company_name_en
            this.research.company_name_ar             = res.data.company_name_ar
            this.research.ind_search_egyptian         = res.data.ind_search_egyptian
            this.research.ind_search_foreign          = res.data.ind_search_foreign
            this.research.digital_doc_file_key        = res.data.digital_doc_file_key
            this.research.digital_doc_file_name       = res.data.digital_doc_file_name
            this.research.digital_doc_file_ext       = res.data.digital_doc_file_ext
            this.research.id_card_file_key = res.data.id_card_file_key
            this.research.id_card_file_name = res.data.id_card_file_name
            this.research.id_card_file_ext = res.data.id_card_file_ext
            this.research.ind_lang_english            = res.data.ind_lang_english
            this.research.ind_lang_french             = res.data.ind_lang_french
            this.research.ind_lang_german             = res.data.ind_lang_german
            this.research.ind_lang_other              = res.data.ind_lang_other
            this.research.other_language              = res.data.other_language
            this.research.ind_to_start                = res.data.ind_to_start
            this.research.ind_scientific_dissertation = res.data.ind_scientific_dissertation
            this.research.ind_solve_tech_problem      = res.data.ind_solve_tech_problem
            this.research.ind_feasibility_study       = res.data.ind_feasibility_study
            this.research.ind_other                   = res.data.ind_other
            this.research.other_purpose               = res.data.other_purpose
            this.research.notes = res.data.notes
            this.research.research_digital_patents    = res.data.research_digital_patents

            this.research.research_type_code          = res.data.research_type_code
            this.research.search_period_type_code     = res.data.search_period_type_code
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetResearchService()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDeliverableFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/reports',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.deliverableFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDeliverableFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetPaymentList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/payments',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.paymentList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPaymentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetReceiving() {
      requestApi({
        url: '/receivings/'+ this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.receipt_status_type_code = res.data.receipt_status_type_code
            this.result_notes = res.data.result_notes
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceiving()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },

    fnGetFileIcon(file_ext) {
      return utils.getExtIcon(file_ext)
    }
  }
}
</script>